import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import hooks from 'hooks';
import 'chartjs-plugin-datalabels';
import './App.scss';
import './index.css';

import useTheme from 'hooks/useTheme';
import { LastLocationProvider } from 'react-router-last-location';
import { getVersion } from 'helpers';
import { AppRoutes } from 'consts/routesPath';
import GuidelinePreviewPage from 'pages/GuidelinePreview';
import Security from 'components/Security';
import ForgotPassword from 'pages/ForgotPassword';
import ResetPassword from 'pages/ResetPassword';
import withTooltip from 'HOCs/withTooltips';
import 'react-datepicker/dist/react-datepicker.css';
import lazyRetry from 'components/LazyRetry';
import useCheckVersion from 'hooks/useCheckVersion';
import useColumnsHandler from 'hooks/useColumnsHandler';
import InitPageLayout from 'interfaces/InitPageLayout';
import GlobalHooks from 'components/GlobalHooks';
import DocComponents from 'pages/DocComponents';
import TimezoneProvider from 'providers/TimezoneProvider';
import ColumnsHandlerProvider from 'providers/ColumnsHandlerProvider';

const loading = () => (
  <div className='pt-3 text-center'>
    <Spinner color='primary' />
  </div>
);

const { useExternalJS } = hooks;

// Layout
const DefaultLayout = React.lazy(() => lazyRetry(() => import('./layout/DefaultLayout')));

console.log(process.env.NODE_ENV);

// Pages
const Login = React.lazy(() => lazyRetry(() => import('./pages/Login')));

const onAuthRequired = ({ history }) => history.push('/login');
console.log(`%cVersion ${getVersion()}`, 'color: green');

const App = () => {
  useExternalJS();
  useTheme();
  useCheckVersion();
  useColumnsHandler();

  return (
    <InitPageLayout>
      <Router>
        <ColumnsHandlerProvider>
          <LastLocationProvider>
            <Suspense fallback={loading()}>
              <Security onAuthRequired={onAuthRequired}>
                <TimezoneProvider>
                  <GlobalHooks />
                  <Switch>
                    <Route
                      path={'/docs/components'}
                      name='Components'
                      render={(props) => <DocComponents {...props} />}
                    />

                    <Route
                      path={AppRoutes.Login}
                      name='Login Page'
                      render={(props) => <Login {...props} />}
                    />

                    <Route
                      path={AppRoutes.ForgotPassword}
                      name='Forgot Password'
                      render={(props) => <ForgotPassword {...props} />}
                    />

                    <Route
                      path={AppRoutes.ResetPassword}
                      name='Reset Password'
                      render={(props) => <ResetPassword {...props} />}
                    />

                    <Route
                      path={AppRoutes.Guide}
                      name='Guide'
                      render={(props) => <GuidelinePreviewPage {...props} />}
                    />
                    <Route
                      path={AppRoutes.HomePage}
                      name='Home'
                      render={(props) => <DefaultLayout {...props} />}
                    />
                    <Route
                      path={AppRoutes.Shortlink}
                      name='Shortlink'
                      render={(props) => <DefaultLayout {...props} />}
                    />
                  </Switch>
                </TimezoneProvider>
              </Security>
            </Suspense>
          </LastLocationProvider>
        </ColumnsHandlerProvider>
      </Router>
    </InitPageLayout>
  );
};

export default withTooltip(App);
